import { Badge } from '@startupquickstart/frontend';
import { Check, Clock, X } from 'lucide-react';
import { ACCESS_REQUEST_STATUSES, type AccessRequestStatus } from '@/api/access-requests';

export interface AccessRequestStatusBadgeProps {
  status: AccessRequestStatus;
}

/**
 * Status pill for a hotel-portal access request (Pending / Approved / Denied),
 * matching the photo-submissions badge palette.
 *
 * @param props - The request status.
 * @returns The colored badge, or null for an unknown status.
 */
export function AccessRequestStatusBadge({ status }: AccessRequestStatusBadgeProps) {
  switch (status) {
    case ACCESS_REQUEST_STATUSES.pending:
      return (
        <Badge variant="secondary" className="bg-yellow-100 text-yellow-800">
          <Clock className="mr-1 h-3 w-3" />
          Pending
        </Badge>
      );
    case ACCESS_REQUEST_STATUSES.approved:
      return (
        <Badge variant="secondary" className="bg-green-100 text-green-800">
          <Check className="mr-1 h-3 w-3" />
          Approved
        </Badge>
      );
    case ACCESS_REQUEST_STATUSES.denied:
      return (
        <Badge variant="secondary" className="bg-red-100 text-red-800">
          <X className="mr-1 h-3 w-3" />
          Denied
        </Badge>
      );
    default:
      return null;
  }
}
